import React, { useMemo } from "react";
import moment from "moment";

// Helper to calculate Ishraq Start only
function calcIshraqStart(sunrise) {
  if (!sunrise || sunrise === "—") return "—";
  const base = moment(sunrise, ["hh:mm A", "h:mm A"], true);
  if (!base.isValid()) return "—";
  
  // Requirement: Start is Sunrise + 20 minutes
  return base.clone().add(20, "minutes").format("hh:mm A");
}

const OtherTimes = ({ prayerData, textColor, timingColor, moreInfoUrl }) => {
  const bottomData = useMemo(() => {
    const timings = prayerData?.startTimes?.timings || {};
    const sunrise = timings.sunrise || "—";
    const dhuhrStart = timings.dhuhr || "—"; // Requirement: End is Dhuhr Start

    const ishraqStart = calcIshraqStart(sunrise);
    const ishraqEnd = dhuhrStart;

    let sehri = "—";
    // Check if month is Ramadan
    const monthName = (prayerData?.islamicMonth?.name || "").toLowerCase();
    if ((monthName.includes("ramadan") || monthName.includes("ramzan")) && timings.fajr) {
      const fajr = moment(timings.fajr, ["hh:mm A", "h:mm A"], true);
      if (fajr.isValid()) sehri = fajr.clone().subtract(15, "minutes").format("hh:mm A");
    }

    return {
      sunrise,
      ishraqStart,
      ishraqEnd,
      sehri,
      iftar: timings.maghrib || "—",
    };
  }, [prayerData]);

  // Common box style for borders/text
  const boxStyle = {
      borderColor: timingColor,
      color: textColor
  };

  return (
    <div className="w-full text-center mt-[3svh] px-[2svw]">
      
      {/* Ishraq Section */}
      <div className="flex flex-col md:flex-row justify-center items-center gap-[1svh] mb-[2svh]">
        <span className="px-[6svw] py-[1svh] border-[0.5svh] rounded-md font-bold text-[5svh]" style={boxStyle}>
          Start: <span style={{ color: timingColor }}>{bottomData.ishraqStart}</span>
        </span>
        <span className="px-[6svw] py-[1svh] border-[0.5svh] font-bold text-[5svh]" style={boxStyle}>
          ISHRAQ
        </span>
        <span className="px-[6svw] py-[1svh] border-[0.5svh] rounded-md font-bold text-[5svh]" style={boxStyle}>
          End: <span style={{ color: timingColor }}>{bottomData.ishraqEnd}</span>
        </span>
      </div>

      {/* Sunrise / Sehri / Iftar */}
      <div className="flex flex-col sm:flex-row justify-center items-center gap-[4svh] font-bold text-[5svh]" style={{ color: textColor }}>
        <span>SUNRISE {bottomData.sunrise}</span>
        {bottomData.sehri !== "—" && <span>SEHRI {bottomData.sehri}</span>}
        <span>IFTAR {bottomData.iftar}</span>
      </div>

      {/* <div className="mt-[3svh] text-center">
        <a
          href={moreInfoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-[3svh] hover:underline"
          style={{ color: timingColor }}
        >
          More Info
        </a>
      </div> */}
    </div>
  );
};

export default OtherTimes;